exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.approvers[data-v-10411702] {\n  margin-top: 20px;\n}\n.approvers img[data-v-10411702] {\n    max-width: 25px;\n}\n.rejected[data-v-10411702]:last-child {\n  color: #B11D1D;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10411702","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/widrawalRequest/CheckSignList.vue
// module id = fVG+
// module chunks = 1